var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m437 0h-362c-41.351562 0-75 33.648438-75 75v362c0 41.351562 33.648438 75 75 75h362c41.351562 0 75-33.648438 75-75v-362c0-41.351562-33.648438-75-75-75zm-180 390c-74.441406 0-135-60.558594-135-135s60.558594-135 135-135 135 60.558594 135 135-60.558594 135-135 135zm150-240c-24.8125 0-45-20.1875-45-45s20.1875-45 45-45 45 20.1875 45 45-20.1875 45-45 45zm0 0","key":0}),React.createElement("path",{"d":"m407 90c-8.277344 0-15 6.722656-15 15s6.722656 15 15 15 15-6.722656 15-15-6.722656-15-15-15zm0 0","key":1}),React.createElement("path",{"d":"m257 150c-57.890625 0-105 47.109375-105 105s47.109375 105 105 105 105-47.109375 105-105-47.109375-105-105-105zm0 0","key":2})]);
}

Instagram.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Instagram;

Instagram.default = Instagram;
